import { useTranslation } from 'react-i18next';

const PREVIEW_ROWS = [
  { seller: 'Seller A', category: 'Shoes', qc: 'Available', shipping: 'Worldwide', status: 'Active' },
  { seller: 'Seller B', category: 'Hoodies', qc: 'Available', shipping: 'Europe', status: 'Active' },
  { seller: 'Seller C', category: 'Bags', qc: 'On request', shipping: 'Worldwide', status: 'Active' },
  { seller: 'Seller D', category: 'T-Shirts', qc: 'Available', shipping: 'Worldwide', status: 'Updated' },
];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative px-4 md:px-6 py-10 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div className="w-full">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold">
            <i className="ri-sparkling-2-line text-sm" />
            {t('hero.badge')}
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            {t('hero.title')}
          </h1>
          <p className="mt-5 text-foreground-600 text-base md:text-lg leading-relaxed max-w-xl">
            {t('hero.subtitle')}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-semibold text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              {t('hero.cta1')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3.5 rounded-md bg-accent-500 text-background-50 font-semibold text-center whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
            >
              {t('hero.cta2')}
            </a>
          </div>

          <p className="mt-6 flex items-center gap-2 text-sm text-foreground-500">
            <i className="ri-shield-check-line text-primary-600" />
            {t('hero.trust')}
          </p>
        </div>

        <div className="w-full">
          <div className="rounded-lg border border-background-200 bg-white/70 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <span className="font-heading font-semibold text-foreground-950 text-base">
                {t('hero.cardTitle')}
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-700 bg-primary-100 px-2.5 py-1 rounded-full">
                <i className="ri-pulse-line" />
                Live
              </span>
            </div>
            <div className="mt-4 overflow-x-auto">
              <table className="w-full text-left text-xs">
                <thead>
                  <tr className="text-foreground-500 border-b border-background-200">
                    <th className="py-2 pr-3 font-medium whitespace-nowrap">{t('hero.cardSeller')}</th>
                    <th className="py-2 pr-3 font-medium whitespace-nowrap">{t('hero.cardCategory')}</th>
                    <th className="py-2 pr-3 font-medium whitespace-nowrap">{t('hero.cardQc')}</th>
                    <th className="py-2 pr-3 font-medium whitespace-nowrap">{t('hero.cardShipping')}</th>
                    <th className="py-2 font-medium whitespace-nowrap">{t('hero.cardStatus')}</th>
                  </tr>
                </thead>
                <tbody>
                  {PREVIEW_ROWS.map((row) => (
                    <tr key={row.seller} className="border-b border-background-100 last:border-0">
                      <td className="py-2.5 pr-3 font-medium text-foreground-800 whitespace-nowrap">{row.seller}</td>
                      <td className="py-2.5 pr-3 text-foreground-600 whitespace-nowrap">{row.category}</td>
                      <td className="py-2.5 pr-3 whitespace-nowrap">
                        <span className="inline-flex items-center gap-1 text-secondary-700">
                          <i className="ri-checkbox-circle-line" />
                          {row.qc}
                        </span>
                      </td>
                      <td className="py-2.5 pr-3 text-foreground-600 whitespace-nowrap">{row.shipping}</td>
                      <td className="py-2.5 whitespace-nowrap">
                        <span className="inline-flex items-center gap-1 text-primary-700">
                          <i className="ri-check-line" />
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-xs text-foreground-500">{t('hero.disclaimer')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}